import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {
    const lblBlocks = Array.from(document.querySelectorAll('.line-by-line-block:not(.intro-copy)'))

    lblBlocks.forEach((lblContainer, i) => {
      let lineScene = new ScrollMagic.Scene({
        triggerElement: lblContainer,
        triggerHook: 'onEnter',
        // offset: height * -.3
      })
      .setClassToggle(lblContainer, 'animate')
      .reverse(false)
      .addTo(scrollController);
    })
  }

  return {
    init
  }

})();
